module.exports = __webpack_public_path__ + "img/persons.40901a2e.svg";